export default __webpack_public_path__ + "static/media/DBInActive1.4b3008f7.svg";